import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "../../lib/utils"

const Slider = React.forwardRef(({ className, start, end, ...props }, ref) => (
  <div className="flex flex-col items-center">
    {start &&
      <span className="text-xs pb-1">
        {start}
      </span>
    }

    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center bg-white/20",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full">
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
    </SliderPrimitive.Root>

    {end &&
      <span className="text-xs pt-1">
        {end}
      </span>
    }
  </div>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
